import StatusesPopup from './StatusesPopup';

export default StatusesPopup;
